const init = () => {
    return new Promise<any>((resolve, reject) => {
        // console.log("init basic")
        resolve( true )
        reject( false )
    }) 
}
export default init